import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from '@personal-area/global/ui'
import { TranslateModule } from '@ngx-translate/core';
import { IconSpriteModule } from '@personal-area/icon-sprite';

export interface SkipData {
  text: string;
}

@Component({
  templateUrl: './skip-verification-dialog.component.html',
  styleUrls: ['./skip-verification-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatDialogModule,
    IconSpriteModule,
    RouterLink,
    ButtonComponent,
    TranslateModule,
    TranslateModule,
  ],
})
export class SkipVerificationDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: SkipData) {
  }
}
